/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 11:52:28
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

export const FILL_PAYMENTS_DATA = 'FILL_PAYMENTS_DATA';
export const FILL_INVOICES_DATA = 'FILL_INVOICES_DATA';
export const FILL_CORRECTION_INVOICES_DATA = 'FILL_CORRECTION_INVOICES_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/PaymentsAndInvoices/mutation-types.js